import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import WorkMergePrimarySelectionHeader from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergePrimarySelection/WorkMergePrimarySelectionHeader'
import WorkMergeCandidate from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergePrimarySelection/WorkMergeCandidate'
import './index.scss'

const WorkMergePrimarySelection = () => {
    const { rightsholderStore, catalogSearchBulkActionStore } = useContext(StoresContext)
    const works = Array.from(catalogSearchBulkActionStore.mergeWorklist.values())

    return (
        <>
            <WorkMergePrimarySelectionHeader />
            {catalogSearchBulkActionStore.primaryWorkMergeId && (
                <div className="work-merge-primary-selected-banner">
                    <strong>Primary work selected.</strong>&nbsp;Other work titles will become alternate titles.
                </div>
            )}
            <div className="work-merge-panel-list">
                {works.map((work) => (
                    <WorkMergeCandidate
                        key={work.id}
                        work={work}
                        yourShares={rightsholderStore.findSpecificWorkClaimedShares(work.id)}
                        useRadioSelect
                    />
                ))}
            </div>
        </>
    )
}
export default observer(WorkMergePrimarySelection)
